
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/leftBar/openedLeftPanels/openedLeftPanels.scss.css.virtualfile';
        module.exports = {"panel":"_panel_1lyq5_7","opened":"_opened_1lyq5_22"};